import ModuleMain from './ModuleMain.vue';

export default ModuleMain;



// WEBPACK FOOTER //
// ./src/components/parts/modules/modulemain/index.ts